var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWateringCan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2530_866)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 22.841,
    rx: 20.5,
    ry: 19.9143,
    fill: "#367B6E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.461 12.5624C26.3616 12.5624 29.5949 15.3256 30.2072 18.9535C30.8958 19.1388 31.4107 19.7441 31.4107 20.4689V21.4407C31.4107 21.4572 31.4107 21.4736 31.4107 21.4901V21.523C31.4107 21.5395 31.4107 21.556 31.4107 21.5725V23.8291C31.7539 23.6767 32.2963 23.3246 32.9023 22.8737C34.1566 21.9431 35.6482 20.6171 36.4618 19.8265C36.9428 19.3591 37.178 19.0193 37.2415 18.8546C37.3051 18.6899 37.2966 18.7764 37.2585 18.7393C37 18.4881 36.8856 18.1258 36.9364 17.8663C36.9873 17.6069 37.1737 17.4381 37.1737 17.4381L37.5467 17.0757C37.7225 16.9048 37.9556 16.8121 38.1908 16.8121C38.4259 16.8121 38.659 16.9048 38.8349 17.0757L41.4452 19.6123C41.7969 19.9541 41.7969 20.5224 41.4452 20.8642L41.0723 21.2266C41.0659 21.2327 41.0617 21.2368 41.0553 21.243C41.0553 21.243 40.8837 21.4077 40.6316 21.4572C40.3795 21.5066 40.0023 21.4057 39.7502 21.1607C39.729 21.1401 39.8031 21.1215 39.6315 21.1771C39.4599 21.2327 39.1018 21.4448 38.6145 21.9184C38.1738 22.3466 36.2775 24.488 34.5804 26.6457C33.7307 27.7246 32.9192 28.8159 32.326 29.726C32.0294 30.181 31.7899 30.5845 31.631 30.9119C31.4721 31.2393 31.4107 31.5049 31.4107 31.5378C31.4107 32.4088 30.6797 33.1191 29.7835 33.1191H19.4777C18.5815 33.1191 17.8505 32.4088 17.8505 31.5378V26.3987C15.8822 25.0089 14.5961 22.7481 14.5961 20.2053C14.5961 15.9906 18.1238 12.5624 22.461 12.5624ZM22.461 13.6166C18.7107 13.6166 15.6809 16.5609 15.6809 20.2053C15.6809 22.1181 16.5178 23.8291 17.8505 25.0315V21.6054C17.8484 21.5786 17.8484 21.5498 17.8505 21.523C17.8505 21.5066 17.8505 21.4901 17.8505 21.4736V20.4689C17.8505 19.5979 18.5815 18.8876 19.4777 18.8876H29.1055C28.4741 15.8815 25.7451 13.6166 22.461 13.6166ZM38.1908 17.9322L38.0552 18.0805C38.3009 18.3708 38.409 18.8217 38.2586 19.217C38.0975 19.6432 37.7606 20.0632 37.2246 20.5842C36.3707 21.4139 34.8812 22.7358 33.5634 23.7138C32.9044 24.2018 32.3048 24.5991 31.7836 24.8174C31.523 24.9265 31.2751 25.0356 30.9361 24.9656C30.7666 24.9306 30.5716 24.8153 30.4615 24.6527C30.3513 24.49 30.3259 24.3109 30.3259 24.1585V22.0501H18.9353V26.0033C18.948 26.0692 18.948 26.1351 18.9353 26.201V31.5378C18.9353 31.7849 19.2235 32.0649 19.4777 32.0649H29.7835C30.0377 32.0649 30.3259 31.7849 30.3259 31.5378C30.3259 31.1693 30.4572 30.8543 30.6479 30.4672C30.8386 30.0801 31.0992 29.6436 31.4107 29.1659C32.0336 28.2106 32.8726 27.0967 33.7329 26.0033C35.4533 23.8167 37.2373 21.7578 37.8348 21.1771C38.3857 20.6418 38.8476 20.3165 39.2925 20.1724C39.6972 20.0427 40.1231 20.1518 40.4112 20.37L40.5638 20.2383L38.1908 17.9322ZM29.4953 19.9418H19.4777C19.2235 19.9418 18.9353 20.2218 18.9353 20.4689V20.996H30.3259V20.4689C30.3259 20.2671 30.1288 20.0488 29.9191 19.9747C29.7792 20.02 29.6267 20.0076 29.4953 19.9418Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2530_866",
    x: 0,
    y: 0.926758,
    width: 53,
    height: 51.8286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2530_866"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2530_866",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWateringCan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wateringCan.f43041a4a3281d502d14188250345db5.svg";